// Day/night cycle derived from world time. Pure math so both the sim (mob
// spawning) and the render layer (sky colour, sun position) can read it.

import { DAY_LENGTH } from './constants';
import { clamp } from './math';

export interface SkyState {
  /** 0 = midnight, 0.5 = noon (fraction of the day). */
  fraction: number;
  /** Global daylight 0 (night) .. 1 (full day). */
  light: number;
  /** Sun angle in radians for positioning the directional light. */
  sunAngle: number;
  isNight: boolean;
}

export function skyState(time: number): SkyState {
  const fraction = (time % DAY_LENGTH) / DAY_LENGTH;
  // Sun elevation: peaks at noon (fraction 0.5).
  const sunAngle = fraction * Math.PI * 2 - Math.PI / 2;
  const elevation = Math.sin(fraction * Math.PI * 2 - Math.PI / 2 + Math.PI / 2);
  // Map elevation (-1..1) to a light level with a soft dawn/dusk ramp.
  const light = clamp((elevation + 0.2) / 0.7, 0.05, 1);
  const isNight = light < 0.3;
  return { fraction, light, sunAngle, isNight };
}
